import { render } from "./More.vue?vue&type=template&id=11f4db91&scoped=true"
import script from "./More.vue?vue&type=script&lang=js"
export * from "./More.vue?vue&type=script&lang=js"

import "./More.vue?vue&type=style&index=0&id=11f4db91&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f4db91"]])

export default __exports__